const client = new ampDynamicContent.ContentClient({
  hubName: 'monetatesandbox',
});


function renderBanner(content) {
  const { image, textPositioning, bannerText, ctaSettings } = content;
  const img = image.img.image.image
  const template = `
    <section class="amp-banner">
      <img src="${img.url().build()}" alt="${image.imageAltText}" />
      <div class="amp-text">
        <h2 class="amp-header">${bannerText.header}</h2>
        <h4 class="amp-description">${bannerText.description}</h4>
        <a href="https://${ctaSettings.linkUrl}" class="amp-button">${ctaSettings.buttonText}</a>
      </div>
    </section>
  `
  const hero = document.getElementById('shopify-section-hero-1')
  hero.innerHTML = template
}

async function getEngineData() {
  const url = "https://engine.monetate.net/api/engine/v1/decide/monetate-post-sales";
  const body = {
    channel: document.location.host == 'amplience.monetate.me' ? "a-57b88a6f/p/amplience.monetate.me" : "a-1db61f7a/p/monetate.me", 
    events: [
        {
            eventType: "monetate:decision:DecisionRequest",
            requestId: "Amplience POC",
            includeReporting: false
        },
        {
            eventType: "monetate:context:PageView",
            url: "https://monetate.me/",
            pageType: "index"
        }
    ]
  }
  
  try {
    const response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
    },
  body: JSON.stringify(body),
});
    if (!response.ok) {
      throw new Error(`Response status: ${response.status}`);
    } else {
      const data = await response.json(); 
      const actions = data.data.responses[0].actions;
      const bannerAction = actions.find(action => action.component === 'xmas-banner');

      client
        .getContentItemById(bannerAction.json.id)
        .then(response =>{ 
          // console.log(response.body)
          renderBanner(response.body)
        })
    }
  } catch (error) {
    console.error(error.message);
  }
}

getEngineData()